export default __webpack_public_path__ + "static/media/cs115.e208ad53.jpg";